module.exports = __webpack_public_path__ + "static/media/eclos-brand-mini-grid.2b06c97a.png";